import { inject } from '@angular/core';
import { from, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { BlockUiService } from '../../../../services';
import { RxRequestOptions } from '../../interfaces';
import { HTTP_UNAUTHORIZED_ERROR_DIALOG } from '../../tokens';
import { handleRequestSuccess } from './handle-operators/success-response.operator';
import { handleRequestError } from './handle-operators/error-response.operator';
import { AuthorizationStrategy } from '../../../../strategies';

/**
 * Creates an rxRequest function bound to the current injection context.
 * Call this in a constructor or field initializer to capture the injector.
 */
export function createRxRequest() {
  const authorizationService = inject(AuthorizationStrategy);
  const UnauthorizedDialog = inject(HTTP_UNAUTHORIZED_ERROR_DIALOG, { optional: true });
  const blockUiService = inject(BlockUiService);
  const translateService = inject(TranslateService);

  return <T>(request: Promise<T>, options?: RxRequestOptions): Observable<T> => {
    return from(request).pipe(
      handleRequestSuccess(options),
      handleRequestError(
        blockUiService,
        authorizationService,
        UnauthorizedDialog,
        translateService,
        options
      )
    );
  };
}
